/**
 * An image mapping table and lookup function.
 *
 * This is here to help keep our back-end and front-end
 * separate. While it's just a simple key/value lookup right now, it
 * allows us to make changes to filenames here on the front-end
 * without upsetting the back-end.
 *
 * NOTE: Please do not change the keys in this table. If you do, you
 * will need to run a migration on the back-end to update the keys
 * there.
 */

export function lookupImage(key, context) {
  return context?.lookupTable?.[key] || key;
}
